"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportRangePermissionInfo = void 0;
var tslib_1 = require("tslib");
var import_bookmark_info_core_1 = require("../../../core/formats/utils/import-bookmark-info-core");
var ImportRangePermissionInfo = (function (_super) {
    tslib_1.__extends(ImportRangePermissionInfo, _super);
    function ImportRangePermissionInfo() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.columnFirst = -1;
        _this.columnLast = -1;
        _this.userName = '';
        _this.group = '';
        return _this;
    }
    return ImportRangePermissionInfo;
}(import_bookmark_info_core_1.ImportBookmarkInfoCore));
exports.ImportRangePermissionInfo = ImportRangePermissionInfo;
